import { z } from 'zod';

const CourseFinderDuration = z.array(z.object({
    Id: z.number(),
    Name: z.string(),
}));

export { CourseFinderDuration };